import { Divider, Rate, Row, Typography } from 'antd';
import React, { FC } from 'react';
import { Criteria } from '../../../screens/webux/webux-pages/review-settings/reviewQuestions';
import { StarFilled } from '@ant-design/icons';
import { UserAvatar } from '../../atoms/UserAvatar';
import { RichText } from '../../RichText/RichText';
import ReactHtmlParser from '../../../utils/SafeHtmlParser';
const { Text } = Typography;
export type Props = {
  criterias: Criteria[];
  onChange?: (value: Criteria[]) => void;
  mode: 'edit' | 'view';
};

const ReviewPreview: FC<Props> = (props) => {
  const { criterias, mode } = props;

  return (
    <div>
      {criterias?.map((item, key) => (
        <div key={key}>
          <CriteriaView
            criteria={item}
            key={key}
            mode={mode}
            onChange={(val) => {
              item.answer = val;
              props.onChange?.(criterias);
            }}
            onComment={(val) => {
              item.comment = val;
              props.onChange?.(criterias);
            }}
          />
          <Divider />
        </div>
      ))}
    </div>
  );
};

export type CriteriaProps = {
  criteria: Criteria;
  onChange?: (value: any) => void;
  onComment?: (value: string) => void;
  mode: 'edit' | 'view';
};

const regex = /(<([^>]+)>)/gi;

export const CriteriaView: FC<CriteriaProps> = (props) => {
  const { criteria, onChange, onComment, mode } = props;
  // const [criteria, setCriteria] = useState<Criteria>({} as Criteria);
  //
  // const events = useEvents();
  // useEffect(() => {
  //   setCriteria(props.criteria);
  // }, [props.criteria]);
  // useEffect(() => {
  //   const handler = () => {
  //     setCriteria({} as Criteria);
  //   };
  //   events.on('PEER_REVIEW_CLOSE', handler);
  //   return () => {
  //     events.off('PEER_REVIEW_CLOSE', handler);
  //   };
  // }, [events]);

  return (
    <div>
      <Row style={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
        <div>
          <StarFilled style={{ color: 'red', fontSize: 7, paddingRight: 5 }} />
          <Text style={{ whiteSpace: 'initial', marginRight: 20 }}>{criteria.name}</Text>
        </div>
        <Rate
          value={criteria?.answer ?? 0}
          character={<StarFilled style={{ fontSize: 15 }} />}
          count={criteria.type}
          onChange={onChange}
          disabled={mode !== 'edit'}
        />
      </Row>
      <div>
        <Text type="secondary">{criteria.description}</Text>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', margin: '10px 0 10px 0', width: '100%' }}>
          <div style={{ width: '32px !important', height: 32 }}>
            <UserAvatar src={undefined} />
          </div>
          <div style={{ marginLeft: 10, flex: 1 }}>
            {mode === 'edit' && (
              // <TextArea
              //   placeholder="Add Comment"
              //   allowClear
              //   value={criteria.comment}
              //   autoSize={{ minRows: 1, maxRows: 3 }}
              //   onChange={(e) => onComment?.(e.target.value)}
              // />
              <RichText
                placeholder={'Add Comment'}
                value={criteria.comment}
                maxLength={10000}
                onChange={(e) => onComment?.(e)}
              />
            )}
            {mode === 'view' && (
              <Typography
                style={{ fontSize: 17, color: 'grey', padding: 0, width: 500, cursor: 'default' }}>
                {criteria.comment === ''
                  ? ''
                  : criteria.comment && !!criteria.comment?.replace(regex, '').length
                  ? ReactHtmlParser(criteria.comment)
                  : ''}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewPreview;
